export default "__VITE_ASSET__CAEt1LhN__"